import * as React from 'react'
import { Col, DatePicker, Form, Modal, Radio, Row } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { withTranslation, WithTranslation } from 'react-i18next';
import autobind from 'autobind-decorator';
import { GetFieldDecoratorOptions } from 'antd/lib/form/Form';
import moment, { Moment } from 'moment';
import i18next from 'i18next';

let FormItem = Form.Item;
const { RangePicker } = DatePicker;

interface ExportParamsViewProps {
    onOk: () => void;
    onCancel: () => void;
    onValueChange: (period: string) => void;
    disableDates?: any;
    defaultCustomDate?: boolean;
    defaultValuesCustomDate?: {
        start: string | null,
        end: string | null
    }
}

interface ExportParamsViewState {
    start: Date;
    end: Date;
    period: string;
}

interface ClassFormBodyProps extends WithTranslation {
    //dates: RangePickerValue,
    onSave?: (start: Date, end: Date) => void;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    disableDates?: any;
    defaultCustomDate?: boolean;
    defaultValuesCustomDate?: {
        start: string | null,
        end: string | null
    };
    onChangePeriod: (value: string) => void;
}

export class ExportParamsFormBody extends React.Component<ClassFormBodyProps, { selectedValue: number, start: Date, end: Date, endOpen: boolean }> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        moment.updateLocale(i18next.language, {
            week: {
                dow: 1, // Monday is the first day of the week.
            }
        });

        var dates = this.getCurrentPeriod(1);
        this.state = {
            selectedValue: this.props.defaultCustomDate ? 3 : 1,

            start: this.props.defaultCustomDate && this.props.defaultValuesCustomDate?.start ?
                this.getUtcFromLocal(moment(this.props.defaultValuesCustomDate?.start)).toDate() :
                this.getUtcFromLocal(dates[0]).toDate(),
            end: this.props.defaultCustomDate && this.props.defaultValuesCustomDate?.end ?
                this.getUtcFromLocal(moment(this.props.defaultValuesCustomDate?.end)).endOf("day").toDate() :
                this.getUtcFromLocal(dates[1]).endOf("day").toDate(),
            endOpen: false
        };
        if (this.props.onSave)
            this.props.onSave(this.state.start, this.state.end);
    }

    private getUtcFromLocal(m: Moment) {
        return moment.utc(m.format("DD-MM-YYYY"), "DD-MM-YYYY");
    }

    private getPeriodStr(periodType: number) {
        switch (periodType) {
            case 2:
                return 'month';
            case 3:
                return 'custom';
            case 1:
                return 'isoWeek';
            default:
                return 'isoWeek';
        }
    }
    @autobind
    private onPeriodChange(e: any) {
        let periodStr = this.getPeriodStr(e.target.value);
        this.props.onChangePeriod(periodStr);
        var dates = this.getCurrentPeriod(e.target.value);
        this.setState({
            selectedValue: e.target.value,
            start: this.getUtcFromLocal(dates[0]).toDate(),
            end: this.getUtcFromLocal(dates[1]).endOf("day").toDate()
        }, () => {
            if (this.props.onSave)
                this.props.onSave(this.state.start, this.state.end);
        });
    }
    getCurrentPeriod(periodType: number) {
        moment.updateLocale(i18next.language, {
            week: {
                dow: 1, // Monday is the first day of the week.
            }
        });
        let currentDate = moment();

        let periodStr: 'isoWeek' | 'month' | 'custom';
        switch (periodType) {
            case 2:
                periodStr = 'month';
                break;
            case 3:
                periodStr = 'custom';
                return [moment(this.state.start), moment(this.state.end)];
            case 1:
            default:
                periodStr = 'isoWeek';
                break;
        }

        let periodStart = currentDate.clone().startOf(periodStr);
        let periodEnd = currentDate.clone().endOf(periodStr);

        return [periodStart, periodEnd];
    }

    @autobind
    private changeStart(date: any, dateString: string) {
        this.setState({ start: moment.utc(dateString, "DD-MM-YYYY").toDate() }, () => {
            if (this.props.onSave)
                this.props.onSave(this.state.start, this.state.end);
        });

    }

    @autobind
    private changeEnd(date: any, dateString: string) {
        this.setState({ end: moment.utc(dateString, "DD-MM-YYYY").endOf("day").toDate() }, () => {
            if (this.props.onSave)
                this.props.onSave(this.state.start, this.state.end);
        });
    }

    private disableStartDate = (current: moment.Moment | null) => {
        return current && current.weekday() > 0;
    }

    private disableEndDate(current: moment.Moment | null) {
        return current && current.weekday() < 6;
    }
    render() {
        const { t, defaultCustomDate } = this.props;
        return <Form id="modaForm">
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={""}>
                        <Radio.Group onChange={this.onPeriodChange} defaultValue={defaultCustomDate ? 3 : undefined}>
                            {!defaultCustomDate && <Radio value={1}>{t('This Week')}</Radio>}
                            {!defaultCustomDate && <Radio value={2}>{t('This Month')}</Radio>}
                            {defaultCustomDate && <Radio value={3}>{t('Custom')}</Radio>}
                        </Radio.Group>
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={""} style={{ display: this.state.selectedValue != 3 ? "none" : "block" }}>
                        <DatePicker
                            name={"start_picker"}
                            format={"DD-MM-YYYY"}
                            onOpenChange={(status) => { this.setState({ endOpen: !status }) }}
                            disabled={defaultCustomDate ? this.disableStartDate : true as any}
                            defaultValue={this.getCurrentPeriod(this.state.selectedValue)[0] as any}
                            onChange={this.changeStart}
                        />
                        <DatePicker
                            name={"end_picker"}
                            format={"DD-MM-YYYY"}
                            open={this.state.endOpen}
                            onOpenChange={(status) => { this.setState({ endOpen: status }) }}
                            disabled={true}
                            defaultValue={this.getCurrentPeriod(this.state.selectedValue)[1] as any}
                            onChange={this.changeEnd}
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    }
}

class ExportParamsView extends React.Component<ExportParamsViewProps & WithTranslation & FormComponentProps, ExportParamsViewState> {
    constructor(props: ExportParamsViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            start: new Date(),
            end: new Date(),
            period: ''
        };
    }
    @autobind
    private onOk() {
        this.props.onValueChange(this.state.period);
    }

    @autobind
    private onChangePicker(start: Date, end: Date) {
        this.setState({ start: start, end: end });
    }

    @autobind
    private onChangePeriod(value: string) {
        this.setState({ period: value });
    }

    @autobind
    private onCancel() {
        this.props.onCancel();
    }

    private showOk() {
        let hideButton = true; 
        if (this.state.period != '' || this.props.defaultCustomDate) {
            hideButton = false;
        }

        return hideButton;
    }

    public render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancel}
                onOk={this.onOk}
                closable={false}
                width='600px'
                title={t("Choose dates")}
                okText={t("OK")}
                cancelText={t("Cancel")}
                zIndex={999}
                okButtonProps={{ disabled: this.showOk() } }
            >
                <ExportParamsFormBody
                    i18n={this.props.i18n}
                    t={this.props.t}
                    tReady={this.props.tReady}
                    getFieldDecorator={getFieldDecorator}
                    onSave={this.onChangePicker}
                    onChangePeriod={this.onChangePeriod}
                    defaultCustomDate={this.props.defaultCustomDate}
                    defaultValuesCustomDate={this.props.defaultValuesCustomDate}
                />
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(ExportParamsView as any) as any) as any as React.ComponentClass<ExportParamsViewProps>;